module.exports = __webpack_public_path__ + "img/SA_image.34e97fbe.png";